module.exports = __webpack_public_path__ + "static/pic22-c872f79eb96ee6d5ec7aaa060774276d.png";